import SeasonList from './seasons.list';
export const SeasonStores = {
    list: SeasonList,
};